var _defs, _defs2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgErrorData(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 500 500",
    style: {
      enableBackground: "new 0 0 500 500"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    id: "BACKGROUND"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "466.374,181.059 459.777,181.059 459.777,174.462 455.096,174.462 455.096,181.059  448.5,181.059 448.5,185.74 455.096,185.74 455.096,192.337 459.777,192.337 459.777,185.74 466.374,185.74  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "431.515,285.505 425.686,285.505 425.686,279.676 421.55,279.676 421.55,285.505  415.722,285.505 415.722,289.642 421.55,289.642 421.55,295.471 425.686,295.471 425.686,289.642 431.515,289.642  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "182.526,117.823 176.697,117.823 176.697,111.993 172.56,111.993 172.56,117.823  166.732,117.823 166.732,121.959 172.56,121.959 172.56,127.788 176.697,127.788 176.697,121.959 182.526,121.959  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "455.54,210.775 451.313,210.775 451.313,206.547 448.313,206.547 448.313,210.775  444.086,210.775 444.086,213.775 448.313,213.775 448.313,218.002 451.313,218.002 451.313,213.775 455.54,213.775  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "163.511,143.393 159.284,143.393 159.284,139.166 156.284,139.166 156.284,143.393  152.057,143.393 152.057,146.393 156.284,146.393 156.284,150.621 159.284,150.621 159.284,146.393 163.511,146.393  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "52.686,194.38 46.856,194.38 46.856,188.551 42.72,188.551 42.72,194.38 36.892,194.38  36.892,198.517 42.72,198.517 42.72,204.346 46.856,204.346 46.856,198.517 52.686,198.517  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#CAD2F9"
    },
    points: "54.818,376.182 50.591,376.182 50.591,371.954 47.591,371.954 47.591,376.182  43.364,376.182 43.364,379.182 47.591,379.182 47.591,383.409 50.591,383.409 50.591,379.182 54.818,379.182  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E2E6FF"
    },
    cx: 43.364,
    cy: 291.374,
    r: 3.91
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M458.742,247.673c0,1.14-0.924,2.064-2.065,2.064c-1.14,0-2.064-0.924-2.064-2.064 c0-1.14,0.924-2.065,2.064-2.065C457.818,245.608,458.742,246.532,458.742,247.673z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M457.159,377.682c0,2.159-1.75,3.91-3.91,3.91c-2.159,0-3.91-1.75-3.91-3.91 c0-2.159,1.75-3.91,3.91-3.91C455.409,373.772,457.159,375.522,457.159,377.682z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M182.104,83.376c0,1.14-0.924,2.065-2.065,2.065c-1.14,0-2.064-0.924-2.064-2.065 c0-1.14,0.924-2.064,2.064-2.064C181.18,81.311,182.104,82.236,182.104,83.376z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M138.951,85.899c0,2.159-1.75,3.91-3.91,3.91s-3.91-1.751-3.91-3.91c0-2.159,1.751-3.91,3.91-3.91 S138.951,83.74,138.951,85.899z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E2E6FF"
    },
    cx: 210.204,
    cy: 95.899,
    r: 3.91
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M37.755,230.695c0,1.14-0.924,2.065-2.065,2.065c-1.14,0-2.064-0.924-2.064-2.065 c0-1.14,0.924-2.064,2.064-2.064C36.831,228.631,37.755,229.555,37.755,230.695z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M76.718,298.927c0,1.14-0.924,2.065-2.065,2.065c-1.14,0-2.064-0.924-2.064-2.065 c0-1.14,0.924-2.064,2.064-2.064C75.793,296.863,76.718,297.787,76.718,298.927z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M448.605,139.399c0,1.14-0.924,2.065-2.065,2.065c-1.14,0-2.064-0.924-2.064-2.065 c0-1.14,0.924-2.064,2.064-2.064C447.68,137.335,448.605,138.259,448.605,139.399z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M371.682,101.744c0,1.14-0.924,2.064-2.065,2.064c-1.14,0-2.064-0.924-2.064-2.064 c0-1.14,0.924-2.065,2.064-2.065C370.758,99.68,371.682,100.604,371.682,101.744z"
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#E2E6FF"
    },
    cx: 402.915,
    cy: 89.718,
    r: 3.91
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M465.438,357.989c0,1.14-0.924,2.065-2.065,2.065c-1.14,0-2.064-0.924-2.064-2.065 c0-1.14,0.924-2.065,2.064-2.065C464.514,355.924,465.438,356.849,465.438,357.989z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M95.773,89.809c0,1.14-0.924,2.064-2.065,2.064c-1.14,0-2.064-0.924-2.064-2.064 c0-1.14,0.924-2.065,2.064-2.065C94.848,87.744,95.773,88.669,95.773,89.809z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "OBJECTS"
  }, /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#EDF0FC"
    },
    cx: 246.785,
    cy: 400.269,
    rx: 209.893,
    ry: 18.419
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB725F"
    },
    d: "M393.32,391.903c0,0-31.188-63.312,63.951-90.911 C457.271,300.992,463.898,396.934,393.32,391.903z"
  }), /*#__PURE__*/React.createElement("g", null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_1_",
    d: "M393.32,391.903c0,0-31.188-63.312,63.951-90.911C457.271,300.992,463.898,396.934,393.32,391.903z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000057149308465214712640000000910394430664257714_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_1_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000057149308465214712640000000910394430664257714_)",
      fill: "#F9AB43"
    },
    d: "M470.029,315.729 l-0.545-0.912c-18.808,11.195-35.927,15.125-40.985,16.106c4.711-5.565,9.357-10.664,13.562-15.079 c1.891-0.352,14.853-3.043,28.013-12.849l-0.636-0.85c-11.078,8.254-21.977,11.383-26.072,12.335 c9.136-9.499,15.889-15.518,16.091-15.697l-0.707-0.794c-0.205,0.181-7.103,6.331-16.401,16.02 c0.897-12.058,6.817-23.87,6.879-23.992l-0.95-0.479c-0.065,0.128-6.5,12.955-7.068,25.664 c-4.216,4.433-8.872,9.548-13.592,15.13c0.339-15.782,7.096-34.273,7.166-34.464l-0.998-0.367 c-0.074,0.198-7.27,19.88-7.249,36.117c-4.551,5.441-9.13,11.299-13.41,17.388c-0.833-22.733,5.886-46.181,5.956-46.421 l-1.023-0.294c-0.072,0.245-7.119,24.82-5.94,48.158c-3.166,4.585-6.15,9.289-8.805,14.035 c-4.708-24.438,1.36-46.622,1.423-46.847l-1.025-0.286c-0.065,0.232-6.416,23.405-1.198,48.591 c-2.604,4.783-4.86,9.597-6.631,14.365c-6.021-17.092-7.191-41.572-6.93-42.985l-1.048-0.191 c-0.281,1.53,0.804,27.069,7.412,44.744c-1.616,4.623-2.763,9.193-3.295,13.634l1.056,0.126 c0.514-4.288,1.611-8.7,3.153-13.165c1.241,0.258,4.824,0.869,10.988,0.869c0.486,0,0.991-0.003,1.511-0.011 c7.958-0.124,21.388-1.338,40.164-6.412l-0.279-1.024c-32.018,8.653-48.822,6.185-52.032,5.562 c1.781-4.949,4.109-9.958,6.813-14.934c0.857,0.084,3.088,0.265,6.339,0.265c10.235,0,30.35-1.815,47.846-14.265l-0.618-0.865 c-21.944,15.616-48.074,14.268-53.009,13.85c2.717-4.905,5.79-9.77,9.066-14.509c3.283-0.333,32.512-3.682,51.983-18.86 l-0.655-0.835c-18.029,14.052-44.588,17.847-50.523,18.539c4.332-6.179,8.982-12.126,13.601-17.641 C429.934,331.777,448.942,328.28,470.029,315.729z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#0046A0"
    },
    d: "M457.271,300.992c-5.628,1.633-10.799,3.394-15.575,5.256 c2.059,6.163,3.186,12.824,3.186,19.776c0,31.588-23.215,57.195-51.853,57.195c-0.912,0-1.819-0.027-2.72-0.079 c1.379,5.442,3.01,8.763,3.01,8.763C463.898,396.934,457.271,300.992,457.271,300.992z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AB43"
    },
    d: "M110.443,385.212c0,0-55.26,13.178-60.087-66.24C50.356,318.973,126.897,330.828,110.443,385.212 z"
  }), /*#__PURE__*/React.createElement("g", null, _defs2 || (_defs2 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    id: "SVGID_00000037673051544886134170000007400015505655062714_",
    d: "M110.443,385.212c0,0-55.26,13.178-60.087-66.24 C50.356,318.973,126.897,330.828,110.443,385.212z"
  }))), /*#__PURE__*/React.createElement("clipPath", {
    id: "SVGID_00000016057509521353776820000007613367004211188397_"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#SVGID_00000037673051544886134170000007400015505655062714_",
    style: {
      overflow: "visible"
    }
  })), /*#__PURE__*/React.createElement("path", {
    style: {
      clipPath: "url(#SVGID_00000016057509521353776820000007613367004211188397_)",
      fill: "#EB725F"
    },
    d: "M64.192,311.598 l-0.813,0.265c5.463,16.72,5.517,30.826,5.392,34.962c-3.537-4.679-6.719-9.223-9.443-13.301 c0.058-1.543,0.241-12.174-5.132-24.224l-0.78,0.347c4.521,10.143,5.049,19.235,5.071,22.611 c-5.843-8.843-9.375-15.201-9.48-15.392l-0.749,0.413c0.106,0.193,3.715,6.688,9.68,15.692 c-9.313-2.845-17.544-9.58-17.629-9.65l-0.545,0.659c0.089,0.074,9.026,7.393,18.908,10.096 c2.736,4.09,5.929,8.645,9.478,13.334c-12.338-3.07-25.666-11.647-25.804-11.736l-0.465,0.716 c0.142,0.093,14.329,9.226,27.088,12.095c3.468,4.531,7.259,9.159,11.284,13.592c-18.005-3.387-35.235-12.815-35.411-12.912 l-0.413,0.749c0.18,0.1,18.236,9.986,36.778,13.208c3.041,3.295,6.208,6.467,9.465,9.39 c-20.032-0.654-36.383-9.349-36.549-9.438l-0.406,0.752c0.171,0.092,17.249,9.184,37.958,9.571 c3.296,2.889,6.678,5.511,10.11,7.746c-14.494,1.679-33.931-1.754-34.995-2.209l-0.336,0.787 c1.152,0.492,21.406,4.18,36.462,2.144c3.345,2.087,6.732,3.797,10.126,5.003l0.286-0.805 c-3.277-1.164-6.549-2.807-9.783-4.808c0.423-0.926,1.538-3.624,2.629-8.451c0.086-0.381,0.173-0.777,0.259-1.185 c1.312-6.255,2.737-16.989,2.078-32.596l-0.854,0.036c1.125,26.615-3.79,39.337-4.848,41.741 c-3.572-2.274-7.094-4.988-10.525-7.989c0.217-0.656,0.755-2.371,1.331-4.918c1.813-8.017,3.951-24.094-2.73-40.008 l-0.788,0.33c8.38,19.961,2.692,40.187,1.49,43.978c-3.371-3-6.649-6.271-9.792-9.678c0.32-2.63,2.867-26.118-5.607-44.065 l-0.772,0.365c7.845,16.617,6.121,38.093,5.614,42.864c-4.087-4.491-7.934-9.189-11.449-13.787 C69.696,345.853,70.317,330.344,64.192,311.598z"
  }))), /*#__PURE__*/React.createElement("path", {
    style: {
      opacity: 0.1,
      fill: "#0046A0"
    },
    d: "M50.356,318.973c0.285,4.698,0.753,9.061,1.37,13.133 c5.207-0.518,10.639-0.217,16.1,1.018c24.814,5.612,40.817,28.344,35.744,50.774c-0.162,0.714-0.344,1.42-0.544,2.116 c4.52-0.113,7.417-0.801,7.417-0.801C126.897,330.828,50.356,318.973,50.356,318.973z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E7FDD"
    },
    d: "M404.607,349.989c0,4.4-3.6,8-8,8H96.963c-4.4,0-8-3.6-8-8V169.426c0-4.4,3.6-8,8-8h299.644 c4.4,0,8,3.6,8,8V349.989z"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 97.872,
    y: 171.066,
    style: {
      fill: "#D0DBF7"
    },
    width: 297.826,
    height: 177.282
  }), /*#__PURE__*/React.createElement("rect", {
    x: 197.784,
    y: 357.989,
    style: {
      fill: "#8397ED"
    },
    width: 98.002,
    height: 24.544
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E7FDD"
    },
    d: "M342.691,396.624c-17.923-14.47-54.141-24.363-95.906-24.363s-77.983,9.893-95.906,24.363H342.691 z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#8397ED"
    },
    d: "M150.879,399.124c1.713,0,3.426,0,5.139,0c4.661,0,9.323,0,13.984,0c6.859,0,13.718,0,20.577,0 c8.404,0,16.808,0,25.212,0c9.206,0,18.413,0,27.619,0c9.252,0,18.504,0,27.756,0c8.666,0,17.333,0,25.999,0 c7.323,0,14.645,0,21.968,0c5.245,0,10.49,0,15.734,0c2.497,0,5.003,0.061,7.5,0c0.108-0.003,0.216,0,0.323,0 c3.217,0,3.223-5,0-5c-1.713,0-3.426,0-5.139,0c-4.661,0-9.323,0-13.984,0c-6.859,0-13.718,0-20.577,0 c-8.404,0-16.808,0-25.212,0c-9.206,0-18.413,0-27.619,0c-9.252,0-18.504,0-27.756,0c-8.666,0-17.333,0-25.999,0 c-7.323,0-14.645,0-21.968,0c-5.245,0-10.49,0-15.734,0c-2.497,0-5.003-0.061-7.5,0c-0.108,0.003-0.216,0-0.323,0 C147.662,394.124,147.656,399.124,150.879,399.124L150.879,399.124z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 114.139,
    y: 183.4,
    style: {
      fill: "#FFFFFF"
    },
    width: 265.292,
    height: 153.383
  }), /*#__PURE__*/React.createElement("rect", {
    x: 114.139,
    y: 183.4,
    style: {
      fill: "#E2E6FF"
    },
    width: 265.292,
    height: 14.78
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB725F"
    },
    d: "M127.035,191.13c0,1.868-1.514,3.382-3.382,3.382c-1.868,0-3.382-1.514-3.382-3.382 c0-1.868,1.514-3.382,3.382-3.382C125.52,187.748,127.035,189.262,127.035,191.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AB43"
    },
    d: "M138.423,191.13c0,1.868-1.514,3.382-3.382,3.382c-1.868,0-3.382-1.514-3.382-3.382 c0-1.868,1.514-3.382,3.382-3.382C136.909,187.748,138.423,189.262,138.423,191.13z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E7FDD"
    },
    d: "M149.812,191.13c0,1.868-1.514,3.382-3.382,3.382c-1.868,0-3.382-1.514-3.382-3.382 c0-1.868,1.514-3.382,3.382-3.382C148.298,187.748,149.812,189.262,149.812,191.13z"
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#E2E6FF"
    },
    d: "M340.523,263.056c0,9.141-7.856,16.62-17.457,16.62H175.468c-9.602,0-17.457-7.479-17.457-16.62 c0-9.141,7.856-16.62,17.457-16.62h147.598C332.667,246.436,340.523,253.915,340.523,263.056z"
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E7FDD"
    },
    d: "M194.52,270.891l-6.057-5.636c0.914-1.294,1.386-2.84,1.328-4.451 c-0.07-1.945-0.893-3.746-2.318-5.072c-1.425-1.326-3.28-2.017-5.225-1.947c-1.945,0.07-3.746,0.893-5.071,2.318 c-1.326,1.425-2.018,3.281-1.948,5.225c0.07,1.945,0.893,3.746,2.318,5.072c1.425,1.326,3.28,2.017,5.225,1.947 c1.61-0.058,3.118-0.639,4.343-1.644l6.057,5.636L194.52,270.891z M178.895,264.952c-1.038-0.966-1.637-2.278-1.688-3.694 c-0.051-1.417,0.453-2.768,1.419-3.806c0.965-1.038,2.278-1.637,3.694-1.688c1.417-0.051,2.768,0.453,3.806,1.418v0 c1.038,0.966,1.637,2.278,1.688,3.694c0.051,1.417-0.453,2.768-1.419,3.806c-0.966,1.038-2.278,1.637-3.694,1.688 C181.284,266.422,179.932,265.918,178.895,264.952z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6C3F2"
    },
    cx: 220.785,
    cy: 262.773,
    r: 1.713
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6C3F2"
    },
    cx: 240.785,
    cy: 262.773,
    r: 1.713
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6C3F2"
    },
    cx: 260.785,
    cy: 262.773,
    r: 1.713
  }), /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#B6C3F2"
    },
    cx: 280.785,
    cy: 262.773,
    r: 1.713
  })))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 306.447,
    y: 123.526,
    style: {
      fill: "#F5F9FF"
    },
    width: 132.047,
    height: 145.279
  }), /*#__PURE__*/React.createElement("rect", {
    x: 306.447,
    y: 123.526,
    style: {
      fill: "#E2E6FF"
    },
    width: 132.047,
    height: 16.377
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB725F"
    },
    d: "M320.736,132.092c0,2.07-1.678,3.748-3.748,3.748s-3.748-1.678-3.748-3.748 c0-2.07,1.678-3.748,3.748-3.748S320.736,130.023,320.736,132.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AB43"
    },
    d: "M333.356,132.092c0,2.07-1.678,3.748-3.748,3.748s-3.748-1.678-3.748-3.748 c0-2.07,1.678-3.748,3.748-3.748S333.356,130.023,333.356,132.092z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#6E7FDD"
    },
    d: "M345.975,132.092c0,2.07-1.678,3.748-3.748,3.748s-3.748-1.678-3.748-3.748 c0-2.07,1.678-3.748,3.748-3.748S345.975,130.023,345.975,132.092z"
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 417.581,
    y: 207.2,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -47.5169 368.8123)",
    style: {
      fill: "#EB725F"
    },
    width: 7.713,
    height: 69.128
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    x: 396.184,
    y: 213.652,
    transform: "matrix(0.7071 -0.7071 0.7071 0.7071 -40.0619 350.8143)",
    style: {
      fill: "#6E7FDD"
    },
    width: 14.512,
    height: 20.228
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", {
    style: {
      opacity: 0.2
    }
  }, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F5F9FF"
    },
    d: "M396.997,217.324c-12.785,12.785-33.589,12.785-46.374,0s-12.785-33.589,0-46.374 s33.589-12.785,46.374,0S409.782,204.539,396.997,217.324z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB725F"
    },
    d: "M400.11,220.437c-14.501,14.501-38.098,14.502-52.599,0s-14.501-38.098,0-52.599 c14.501-14.501,38.098-14.502,52.599,0C414.611,182.339,414.611,205.935,400.11,220.437z M352.964,173.291 c-11.495,11.495-11.494,30.197,0,41.691c11.494,11.494,30.197,11.495,41.691,0c11.495-11.495,11.494-30.197,0-41.691 C383.161,161.797,364.459,161.796,352.964,173.291z"
  })))), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F9AB43"
    },
    points: "390.12,182.63 385.317,177.827 373.81,189.334 362.303,177.827 357.5,182.63  369.007,194.137 357.5,205.643 362.303,210.447 373.81,198.94 385.317,210.447 390.12,205.643 378.613,194.137  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EB725F"
    },
    points: "163.382,291.374 103.649,291.374 103.649,399.285 195.784,399.285 195.784,322.414  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#F4AEA6"
    },
    points: "163.382,291.374 195.784,322.414 163.382,322.414  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M139.89,332.845c0,3.239-1.882,5.865-4.203,5.865c-2.321,0-4.203-2.626-4.203-5.865 c0-3.239,1.882-5.865,4.203-5.865C138.008,326.98,139.89,329.606,139.89,332.845z"
  }), /*#__PURE__*/React.createElement("ellipse", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 163.629,
    cy: 332.845,
    rx: 4.203,
    ry: 5.865
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M137.968,350.451c1.749-1.915,4.181-3.421,6.602-4.294c6.126-2.209,12.048,0.099,16.714,4.294 c1.246,1.12,3.097-0.72,1.845-1.845c-5.173-4.65-11.883-7.382-18.764-5.133c-3.018,0.986-6.082,2.766-8.243,5.133 C134.993,349.844,136.833,351.695,137.968,350.451L137.968,350.451z"
  })))))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AB43"
    },
    d: "M131.909,109.422h-67.19c-4.008,0-7.287,3.279-7.287,7.287v47.131c0,4.008,3.279,7.287,7.287,7.287 h23.608l9.987,12.165l9.987-12.165h23.608c4.008,0,7.287-3.279,7.287-7.287v-47.131 C139.196,112.701,135.917,109.422,131.909,109.422z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#FFFFFF"
    },
    d: "M98.314,118.179c-12.269,0-22.25,9.981-22.25,22.25c0,12.269,9.981,22.25,22.25,22.25 c12.269,0,22.25-9.982,22.25-22.25C120.564,128.16,110.583,118.179,98.314,118.179z M98.314,122.374 c4.223,0,8.109,1.462,11.188,3.9L84.16,151.617c-2.438-3.079-3.9-6.965-3.9-11.188C80.259,130.474,88.359,122.374,98.314,122.374z  M98.314,158.483c-4.223,0-8.109-1.461-11.188-3.9l25.342-25.342c2.439,3.078,3.9,6.965,3.9,11.188 C116.369,150.384,108.27,158.483,98.314,158.483z"
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D0DBF7"
    },
    points: "382.699,298.928 326.972,298.56 326.308,399.232 412.262,399.8 412.736,328.085  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3EBFC"
    },
    points: "382.699,298.928 412.736,328.085 382.508,327.885  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEF4FF"
    },
    points: "387.847,336.455 382.539,331.077 369.653,343.793 356.935,330.908 351.557,336.216  364.274,349.101 351.388,361.818 356.696,367.196 369.582,354.48 382.3,367.365 387.678,362.057 374.961,349.172  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D0DBF7"
    },
    points: "101.725,221.275 68.375,204.559 38.176,264.808 89.618,290.592 111.129,247.673  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3EBFC"
    },
    points: "101.725,221.275 111.129,247.673 93.039,238.605  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEF4FF"
    },
    points: "93.708,245.331 92.113,240.531 80.612,244.352 76.79,232.85 71.99,234.445  75.811,245.946 64.31,249.767 65.905,254.568 77.406,250.747 81.228,262.248 86.029,260.653 82.207,249.152  "
  })), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#D0DBF7"
    },
    points: "226.476,109.437 199.784,118.123 215.475,166.344 256.647,152.947 245.469,118.596  "
  }), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#E3EBFC"
    },
    points: "226.476,109.437 245.469,118.596 230.99,123.307  "
  })), /*#__PURE__*/React.createElement("polygon", {
    style: {
      fill: "#EEF4FF"
    },
    points: "234.904,126.554 231.512,124.828 227.376,132.955 219.248,128.818 217.522,132.21  225.649,136.347 221.512,144.474 224.904,146.2 229.041,138.073 237.168,142.21 238.895,138.817 230.768,134.681  "
  }))), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#EB725F"
    },
    d: "M308.879,104.81l-2.337-0.008c-0.488-2.066-1.295-4.004-2.369-5.768l1.661-1.649 c1.295-1.286,1.303-3.399,0.016-4.694l-1.927-1.941c-1.287-1.295-3.399-1.303-4.694-0.016l-1.661,1.649 c-1.757-1.085-3.689-1.906-5.751-2.408l0.008-2.338c0.006-1.826-1.482-3.325-3.308-3.331l-2.735-0.009 c-1.826-0.006-3.325,1.482-3.331,3.308l-0.008,2.338c-2.066,0.489-4.004,1.295-5.768,2.369l-1.649-1.661 c-1.287-1.296-3.399-1.303-4.694-0.016l-1.941,1.927c-1.295,1.287-1.303,3.399-0.016,4.694l1.649,1.661 c-1.086,1.757-1.906,3.689-2.409,5.752l-2.338-0.008c-1.826-0.006-3.325,1.482-3.331,3.308l-0.009,2.735 c-0.006,1.826,1.482,3.325,3.308,3.331l2.338,0.008c0.488,2.066,1.295,4.004,2.369,5.768l-1.661,1.649 c-1.295,1.286-1.303,3.399-0.016,4.694l1.927,1.941c1.286,1.295,3.399,1.303,4.695,0.016l1.66-1.649 c1.757,1.086,3.689,1.906,5.752,2.409l-0.008,2.338c-0.006,1.826,1.482,3.325,3.308,3.331l2.735,0.009 c1.826,0.006,3.324-1.482,3.331-3.308l0.008-2.338c2.066-0.488,4.004-1.295,5.768-2.369l1.649,1.661 c1.286,1.295,3.399,1.303,4.694,0.016l1.941-1.927c1.295-1.286,1.303-3.399,0.016-4.694l-1.649-1.66 c1.086-1.757,1.906-3.689,2.409-5.752l2.337,0.008c1.826,0.006,3.325-1.482,3.331-3.308l0.009-2.735 C312.193,106.316,310.704,104.817,308.879,104.81z M287.029,118.684c-5.115-0.018-9.247-4.179-9.23-9.294 c0.018-5.115,4.179-9.247,9.294-9.23c5.115,0.018,9.247,4.178,9.23,9.294C296.305,114.569,292.144,118.701,287.029,118.684z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F9AB43"
    },
    d: "M287.107,96.208c-7.298-0.025-13.235,5.871-13.26,13.168c-0.025,7.298,5.87,13.235,13.168,13.26 c7.298,0.025,13.234-5.871,13.26-13.169C300.3,102.17,294.405,96.233,287.107,96.208z M287.033,117.628 c-4.532-0.016-8.193-3.702-8.178-8.234c0.016-4.532,3.702-8.193,8.234-8.178c4.532,0.016,8.193,3.702,8.178,8.235 C295.251,113.982,291.565,117.644,287.033,117.628z"
  }))), /*#__PURE__*/React.createElement("g", {
    id: "TEXTS"
  }, /*#__PURE__*/React.createElement("text", {
    transform: "matrix(1 0 0 1 125.5764 370.1411)",
    style: {
      fill: "#FFFFFF",
      fontFamily: "'Prompt-Black'",
      fontSize: "11.4745px",
      letterSpacing: 1
    }
  }, "NO DATA")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgErrorData);
export default __webpack_public_path__ + "static/media/error-data.91cc51f03cf179d2755e915878685854.svg";
export { ForwardRef as ReactComponent };